import { render } from "./RecientesView.vue?vue&type=template&id=34f0144f"
import script from "./RecientesView.vue?vue&type=script&lang=js"
export * from "./RecientesView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__